import styled from 'styled-components';
import { Typography } from '@mui/material';

export const TitleCard = styled(Typography)`
  font-size: 0.875rem !important;
  font-weight: bold !important;
  color: #000;
  text-transform: uppercase;
  line-height: 1.75 !important;
  text-align: left;
`;

export const TitleTotal = styled(Typography)`
  font-size: 1rem !important;
  font-weight: bold !important;
  color: #000 !important;
  text-transform: uppercase;
  line-height: 1.75 !important;
  text-align: left;
`;

export const TitleCardValues = styled(Typography)`
  font-size: 1.2rem !important;
  font-weight: bold !important;
  text-transform: uppercase;
  line-height: 1.75 !important;
  text-align: left;
`;

export const LinkMore = styled(Typography)`
  font-size: 0.875rem !important;
  color: #ffcc80;
  line-height: 1.75 !important;
  cursor: pointer;
  margin-top: 15px !important;
  :hover {
    text-decoration: underline;
  }
`;
